export const loginUrl = '/login';
export const mainUrl = '/';
export const personalUrl = '/personal';